var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{class:['v-view-primary', _vm.$store.getters.getIsClientData === false
  ? 'v-view-primary-upgrade' : '']},[_c('OrganismTheHeader'),_c('OrganismNotFound')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }